import DerivativeSelector from './DerivativeSelector.jsx';
import './DerivativeSelector.css';

export default DerivativeSelector;
